import { MarkerType, Position } from "reactflow";

export function formatNodes(organizations = []) {
  return organizations?.map((org) => ({
    id: org?._id?.toString(),
    _id: org?._id?.toString(),
    type: "custom",
    hidden: false,
    expanded: true,
    data: {
      nodeId: org?._id,
      _id: org?._id,
      label: org?.companyName,
      companyName: org?.companyName,
      location: org?.location,
      orgchild: org?.children?.filter((item) => item.isBranch === false),
      totalNoOfShares: org?.totalNoOfShares,
      directors: org?.directors || [],
      shareHolders: org?.shareHolders,
      additionalFields: org?.additionalFields,
      BusinessNature: org?.BusinessNature,
      Incorporationdate: org?.Incorporationdate,
      CompanyRegistrationNumber: org?.CompanyRegistrationNumber,
      BusinessRegistrationNumber: org?.BusinessRegistrationNumber,
      ManagingDirector: org?.ManagingDirector,
      DeputyManagingDirector: org?.DeputyManagingDirector,
      Chairman: org?.Chairman,
      ResidentDirector: org?.ResidentDirector,
      DeputyChairman: org?.DeputyChairman,
      CompanySecretary: org?.CompanySecretary,
      StatutoryAuditor: org?.StatutoryAuditor,
      RepresentativeDirector: org?.RepresentativeDirector,
      LegalRepresentative: org?.LegalRepresentative,
      TotalPaidUpCapital: org?.TotalPaidUpCapital,
      registerCurrency: org?.registerCurrency,
      ParCurrency: org?.ParCurrency,
      CapitalCurrency: org?.CapitalCurrency,
      TotalCurrency: org?.TotalCurrency,
      Remarks: org?.Remarks,
      AuthorizedCapital: org?.AuthorizedCapital,
      ParValueofShares: org?.ParValueofShares,
      TotalPaidUpPremiumtoShares: org?.TotalPaidUpPremiumtoShares,
      totalIssuedPreferenceShares: org?.totalIssuedPreferenceShares,
      PercentageOfShares: org?.PercentageOfShares,
      toolbarPosition: Position?.Right,
      BusinessGroup: org?.BusinessGroup,
      isBranch: org?.isBranch,
      isOperatingCompany: org?.isOperatingCompany,
      jointcompany: org?.jointcompany,
      isJointVentureCompany: org?.isJointVentureCompany,
      JointVentureCompanies: org?.JointVentureCompanies,
      Address: org?.Address,
      parent: org?.parent,
      children: org?.children,
      checked: org?.checked,
      branch: org?.branch,
    },
    children: org?.children,
    Address: org?.Address,
    parent: org?.parent,
    isRoot: org?.isRoot,
    checked: org?.checked,
    isBranch: org?.isBranch,
    isOperatingCompany: org?.isOperatingCompany,
    isJointVentureCompany: org?.isJointVentureCompany,
    JointVentureCompanies: org?.JointVentureCompanies,
    location: org?.location,
    possssss: { xdata: org?.position?.x, ydata: org?.position?.y },
    position: { x: org?.position?.x || 0, y: org?.position?.y || 0 },
  }));
}

export function formatEdges(edges = []) {
  return Array.isArray(edges) && edges?.map((edge) => ({
    id: `e-${edge.source?.toString()}-${edge.target?.toString()}`,
    source: edge.source?.toString(),
    target: edge.target?.toString(),
    markerEnd: {
      type: MarkerType.ArrowClosed,
      width: 12,
      height: 12,
      color: "blue",
    },
    type: "step",
  }));b
}

export function formatNode(org) {
  return {
    id: org._id.toString(),
    type: "custom",
    hidden: false,
    expanded: true,
    data: {
      nodeId: org._id,
      label: org.companyName,
      companyName: org.companyName,
      directors: org.directors || [],
      shareHolders: org.shareHolders,
      orgchild: org.children.filter((item) => item.isBranch === false),
      location: org.location?.address,
      totalNoOfShares: org.totalNoOfShares,
      PercentageOfShares: org.PercentageOfShares || 0,
      toolbarPosition: Position.Right,
      isBranch: org.isBranch,
    },
    children: org.children,
    parent: org.parent,
    isRoot: org.isRoot,
    isBranch: org.isBranch,
    position: { x: org?.position?.x || 0, y: org?.position?.y || 0 },
    location: org.location,
  };
}

export function formatEdge(edge) {
  return {
    id: `e-${edge.source?.toString()}-${edge.target?.toString()}`,
    source: edge.source?.toString(),
    target: edge.target?.toString(),
    markerEnd: {
      type: MarkerType.ArrowClosed,
      width: 12,
      height: 12,
      color: "red",
    },
    type: "step",
  };
}

export function willCreateCycle(nodes, sourceId, targetId) {
  const nodeMap = new Map(nodes?.map((node) => [node.id, node]));

  function hasCycle(currentNodeId, visited, recStack) {
    if (recStack.has(currentNodeId)) {
      return true;
    }
    if (visited.has(currentNodeId)) {
      return false;
    }
    visited.add(currentNodeId);
    recStack.add(currentNodeId);
    const currentNode = nodeMap.get(currentNodeId);
    if (currentNode && currentNode.children) {
      for (const childId of currentNode.children) {
        if (hasCycle(childId, visited, recStack)) {
          return true;
        }
      }
    }
    recStack.delete(currentNodeId);
    return false;
  }

  const temporaryNodeMap = new Map(nodeMap);
  const newChildren = (temporaryNodeMap.get(targetId)?.children || []).concat(
    sourceId
  );
  temporaryNodeMap.set(targetId, {
    ...temporaryNodeMap.get(targetId),
    children: newChildren,
  });

  const visited = new Set();
  const recStack = new Set();

  return hasCycle(targetId, visited, recStack);
}

export const formatAndCombineNodes = (existingNodes = [], newNodes = []) => {
  const combinedNodes = [...existingNodes, ...newNodes];
  const uniqueNodesMap = new Map();
  combinedNodes.forEach((node) => {
    uniqueNodesMap.set(String(node.id), node);
  });
  return Array.from(uniqueNodesMap.values());
};

